import { notificationToast, toast } from '@gmg/gmg-react-components';
import { notificationWithDownloadableFile } from './NotificationWithDownloadLink';

interface SubscriptionResponseHandlerProps extends SubscriptionBaseProps {
    toBeClosedToastIds?: Array<string>;
    notificationTitle: string;
    decoderFn?: (data: string) => string;
};
export interface SubscriptionBaseProps {
    data?: string;
    error?: string;
    licenseSystemId: string | undefined;
    messageId: string;
};
const TOAST_DURATION_IN_MINUTE = 5;

export const createOrReactivateLicenseSystemSubscriptionResponseHandler = (props: SubscriptionResponseHandlerProps) => {
    // Close all toasts which are not desired if any
    props.toBeClosedToastIds?.forEach(id => toast.dismiss(id));

    if (props.error) {
        toast.error(props.error);
    } else if (!props.data) {
        toast.error('An error occurred');
    }

    if (props.data) {
        const fileContent = !!props.decoderFn ? props.decoderFn(props.data) : props.data;

        notificationToast({
            duration: TOAST_DURATION_IN_MINUTE,
            variant: 'success',
            id: props.messageId,
            content: notificationWithDownloadableFile({
                notificationTitle: props.notificationTitle,
                fileName: props.licenseSystemId || 'default',
                fileContent: fileContent,
                fileExtension: 'lic',
                onDownloadClickHandler: () => { toast.dismiss(props.messageId); },
            }),
        });
    }
};